module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"text":"{dateTime} od {displayName}"},"de":{"text":"{dateTime} von {displayName}"},"es":{"text":"{dateTime} por {displayName}"},"fr":{"text":"{dateTime} par {displayName}"}}')
  delete Component.options._Ctor
}
